import React from 'react';
import { Search, MessageSquare, FileText } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    number: '01',
    title: 'Auditoría de Silencio',
    description: 'Identificas las micro-señales de acoso con nuestra auditoría en las primeras 24 horas.',
    icon: <Search size={32} data-id="element-118" />
  }, {
    number: '02',
    title: 'Práctica N.E.A.',
    description: 'Practicas los guiones del Método N.E.A. con tu hijo durante 5 minutos cada noche.',
    icon: <MessageSquare size={32} data-id="element-119" />
  }, {
    number: '03',
    title: 'Presión Administrativa',
    description: 'Usas nuestras plantillas para que el colegio cumpla con sus protocolos legales.',
    icon: <FileText size={32} data-id="element-120" />
  }];
  return <section className="py-24 md:py-32 bg-white relative overflow-hidden" data-id="element-121">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl relative z-10" data-id="element-122">
        <FadeIn data-id="element-123">
          <div className="text-center mb-20" data-id="element-124">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-4" data-id="element-125">
              Cómo funciona el protocolo
            </h2>
            <div className="w-24 h-1 bg-amber mx-auto rounded-full" data-id="element-126"></div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-12 lg:gap-16 relative" data-id="element-127">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-navy/10 z-0" data-id="element-128"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-129">
              <div className="relative z-10 flex flex-col items-center text-center group" data-id="element-130">
                <div className="w-24 h-24 rounded-full bg-offwhite border-4 border-white shadow-xl flex items-center justify-center text-teal mb-8 relative transition-transform duration-500 group-hover:scale-110 group-hover:bg-teal group-hover:text-white" data-id="element-131">
                  {step.icon}
                  <div className="absolute -top-4 -right-4 w-10 h-10 rounded-full bg-amber text-navy font-bold flex items-center justify-center text-sm shadow-md" data-id="element-132">
                    {step.number}
                  </div>
                </div>

                <h3 className="text-2xl font-bold text-navy mb-4" data-id="element-133">
                  {step.title}
                </h3>
                <p className="text-navy/70 leading-relaxed max-w-xs" data-id="element-134">
                  {step.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}